import { useRef, useEffect } from 'react';

export default function IsMountedRef() {
    const isMounted = useRef(true);

    useEffect(() => () => {
        isMounted.current = false;
    }, []);

    return isMounted;
}